<div class="p-2" [ngClass]="value().last_downloaded_at ? 'bg-neutral-300' : ''" data-testid="report_export_download_row">
  <span class="text-xs">{{ value().name }}</span>

  <div class="min-w-32 flex flex-nowrap items-start justify-between">
    <div class="grow flex flex-col gap-0">
      <div class="w-full flex items-center gap-1">
        <mat-progress-bar mode="determinate" [value]="(value().progress * 100).toString()"></mat-progress-bar>
        <span class="ml-2">{{ value().progress * 100 | number: "1.0-2" }}%</span>
      </div>

      <div class="text-xxs text-slate-500 flex items-center">
        <span> Started: {{ value().created_at | date: "MM/dd/yyyy h:mm:ss a" }} </span>
        <mat-icon class="ml-1" matTooltip="Local Time" matTooltipPosition="above"> help_outline </mat-icon>
      </div>

      <div class="text-xxs text-slate-500 flex items-center">
        <span [ngClass]="{ 'text-danger': value().job_status === 'Failed' }"> Job Status: {{ value().job_status ?? "(removed)" }} </span>
        <mat-icon class="ml-1" [matTooltip]="getJobStatusTooltip()" matTooltipPosition="above"> help_outline </mat-icon>
      </div>
    </div>

    <app-pan-button
      icon="download"
      fill="clear"
      size="sm"
      [disabled]="!value().download_url"
      (click)="download.emit()"
      class="ml-1"
      data-testid="report_export_download_button"
    ></app-pan-button>

    @if (canRetry()) {
      <app-pan-button icon="refresh" fill="clear" size="sm" (click)="export.emit()" class="ml-1"> </app-pan-button>
    }
  </div>
</div>
